// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7fa6c2f4","831":"4215f06d"}[chunkId] + ".chunk.js";
};